import { motion } from "framer-motion";
import { fadeIn } from "@/lib/numa-assets";
import { ArrowRight } from "lucide-react";

export const Waitlist = () => {
  // Purely decorative — no submission logic.
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <section
      id="waitlist"
      data-testid="waitlist-section"
      className="bg-[#F9F9F6] border-t border-[#E2E5E0] py-24 sm:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div {...fadeIn} className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-4 mb-10 mx-auto">
            <span className="numa-marker">07</span>
            <span className="h-[1px] w-12 bg-[#8A9A90]" />
            <span className="numa-marker text-[#152219]">Begin</span>
          </div>

          <h2
            className="font-heading text-4xl sm:text-5xl lg:text-[64px] tracking-[-0.025em] font-medium text-[#152219] leading-[1.04]"
            data-testid="waitlist-title"
          >
            Enter the protocol.
          </h2>
          <p className="text-[15px] leading-[1.7] text-[#57635A] mt-8 max-w-md mx-auto">
            NUMA-05 launches in limited release. Reserve a position in the
            opening cohort and receive the protocol briefing ahead of launch.
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-14 max-w-md mx-auto"
            data-testid="waitlist-form"
          >
            <div className="flex items-end gap-6 border-b border-[#152219] pb-3 text-left">
              <label
                htmlFor="numa-email"
                className="sr-only"
                data-testid="waitlist-email-label"
              >
                Email address
              </label>
              <input
                id="numa-email"
                type="email"
                placeholder="your@email"
                className="flex-1 bg-transparent outline-none border-0 text-[15px] text-[#152219] placeholder:text-[#8A9A90] py-2 font-body"
                data-testid="waitlist-email-input"
              />
              <button
                type="submit"
                aria-label="Join the NUMA waitlist"
                className="text-[11px] tracking-[0.28em] uppercase text-[#152219] inline-flex items-center gap-2 group"
                data-testid="waitlist-submit-button"
              >
                Reserve
                <ArrowRight
                  className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1"
                  strokeWidth={1.4}
                />
              </button>
            </div>
            <p
              className="text-[11px] tracking-[0.18em] uppercase text-[#8A9A90] mt-4"
              data-testid="waitlist-microcopy"
            >
              By position only · No marketing · Quietly notified
            </p>
          </form>

          <div className="mt-20 grid grid-cols-3 max-w-xl mx-auto border-t border-[#E2E5E0]">
            {[
              ["Stage", "02"],
              ["Cohort", "Opening"],
              ["Domain", "numaregen.com"],
            ].map(([k, v]) => (
              <div
                key={k}
                className="py-6 border-r last:border-r-0 border-[#E2E5E0]"
                data-testid={`waitlist-meta-${k.toLowerCase()}`}
              >
                <div className="text-[10px] tracking-[0.22em] uppercase text-[#8A9A90]">
                  {k}
                </div>
                <div className="font-heading text-[15px] tracking-tight text-[#152219] mt-1.5">
                  {v}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Waitlist;
